/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { uniq } from 'ramda';
import { asyncSentenceBreak } from '../common/utils/document.util';

const initialState = {
  selectedText: '',
  selectedMarkdown: '',
  doc: '',
  textList: [] as string[],
};

export type CommonState = typeof initialState;

export const sentenceBreak = createAsyncThunk(
  'common/sentenceBreak',
  async (doc: string) => {
    return asyncSentenceBreak(doc);
  },
);

export const common = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setSelectedText: (state, { payload }: PayloadAction<string>) => {
      state.selectedText = payload;
    },
    setSelectedMarkdown: (state, { payload }: PayloadAction<string>) => {
      state.selectedMarkdown = payload;
    },
    setDoc: (state, { payload }: PayloadAction<string>) => {
      if (!payload || state.doc === payload) {
        return;
      }
      state.doc = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sentenceBreak.fulfilled, (state, { payload }) => {
      state.textList = uniq(payload).filter((text) => text.length !== 0);
      console.log(state.textList);
    });
  },
});
